export const Bio = {
  name: "Shakti Priya",
  roles: [
    "Full Stack Developer",
    "Debugger",
    "Tech Enthusiast",

  ],
  description:
    "From responsive frontends to scalable backend systems, I build seamless digital experiences using React, Next.js, Node.js, and modern web technologies.",
  github: "https://github.com/shaktipriya13",
  resume:
    "https://drive.google.com/file/d/1K8rlii591a6H6JJ5D8-o29U9cGQiozxS/view",
    // "https://drive.google.com/file/d/1w_rGdO5Buy1-ji3626zMxrdGf8Wv9Dps/view?usp=sharing",
    // "https://drive.google.com/file/d/1FRjl3QztWy3LH0AIcQkH-Vfh68Olufzp/view?usp=sharing",
    
    
  linkedin: "https://www.linkedin.com/in/shaktipriya13/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
    
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "CSS",
        image:
          "https://static.vecteezy.com/system/resources/previews/066/386/006/non_2x/the-css-logo-icon-free-png.png",
      },
      {
        name: "TypeScript",
        image:"https://images.seeklogo.com/logo-png/29/2/typescript-logo-png_seeklogo-298572.png",
      },
      {
        name: "JavaScript",
        image:
          "https://tse1.mm.bing.net/th/id/OIP.1fuHy5m0ivTEfkM8hYERVgHaHa?pid=Api&P=0&h=180",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind",
        image:
        "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg"
      },
      {
        name: "Animate UI",
        image: "https://tse1.mm.bing.net/th/id/OIP.2LLKWoGByr5u4LvxVn6G9wHaHa?pid=Api&P=0&h=180",
      }
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://1.bp.blogspot.com/-sqAjIvOtpXI/XYoCmqOyMwI/AAAAAAAAJig/CowR8wgEauEs-RXN2IPmLYkC7NHoHuA3gCLcBGAsYHQ/s1600/node-js-logo.png",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      // {
      //   name: "Python",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      // },
      // {
      //   name: "Flask",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      // },
      // {
      //   name: "Django",
      //   image:
      //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      // },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
         name: "Redis",
        image:
          "https://robert.hawdon.net/blog/wp-content/uploads/2014/02/redis-logo.png",
      }
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
    ],
  },
  // {
  //   title: "DevOps",
  //   skills: [
  //     {
  //       name: "AWS",
  //       image:
  //         "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
  //     },
  //     {
  //       name: "Google Cloud",
  //       image:
  //         "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
  //     },
  //     {
  //       name: "Docker",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
  //     },
  //     {
  //       name: "Jenkins",
  //       image:
  //         "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
  //     },
  //     {
  //       name: "Nginx",
  //       image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
  //     },
  //     {
  //       name: "Grafana",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
  //     },
  //     {
  //       name: "Kubernetes",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
  //     },
  //     {
  //       name: "Prometheus",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
  //     },
  //   ],
  // },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "Jetpack Compose",
  //       image:
  //         "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  // {
  //   title: "Machine Learning",
  //   skills: [
  //     {
  //       name: "Python",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
  //     },
  //     {
  //       name: "Tenserflow",
  //       image:
  //         "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
  //     },
  //     {
  //       name: "Keras",
  //       image:
  //         "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
  //     },
  //     {
  //       name: "Jupyter",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
  //     },
  //     {
  //       name: "Google Colab",
  //       image:
  //         "https://assets.stickpng.com/images/63c2e4c9c4baad4ce22bf9ef.png",
  //     },
  //     {
  //       name: "Sk Learn Kit",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "C++",
        image:
          "https://isocpp.org/assets/images/cpp_logo.png"
      },
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
      },
      {
        name: "GitHub",
        image:
          "https://pngimg.com/uploads/github/github_PNG80.png",
      },
      {
        name: "Netlify",
        image:
          "https://images.g2crowd.com/uploads/product/image/social_landscape/social_landscape_4c2c908435a514466a56ed2f4cc49417/netlify.png",
      },
      {
        name: "Render",
        image:
          "https://render.com/brand/render_1105076560.svg",
        },
      {
        name: "Vercel",
        image:
          "https://www.jegkomforsent.no/assets/vercel-logo.959b290d.png",
        },
      {
        name: "VS Code",
        image:
          "https://quarto.org/docs/get-started/images/vscode-logo.png",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg"
      },
      {
        name: "Puppeteer",
        image:
          "https://user-images.githubusercontent.com/10379601/29446482-04f7036a-841f-11e7-9872-91d1fc2ea683.png"
      },
            {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/images/human_capitalists_logo.jpg",
    linkedin: "https://www.linkedin.com/company/human-capitalists/posts/?feedView=all",
    role: "Full Stack Developer Intern",
    company: "Human Capitalists",
    date: "Jan 2026 - Mar 2026",
    desc: [
      "Contributed to a live production platform working across frontend, admin dashboard, and backend services, ensuring seamless integration and scalability.",
      "Built pixel-perfect responsive UI components from Figma designs and enhanced user experience using Animate UI for smooth interactive animations.",
      "Developed and integrated REST APIs, implemented authentication and admin workflows, and tested recruiter-candidate interview flows to improve system reliability.",
    ],
    skills: [
      "ReactJS",
      "NextJS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "REST APIs",
      "Tailwind CSS",
      "Animate UI",
      "JavaScript",
      "TypeScript",
      "Figma",
    ],
    location: "Remote",
  },

  {
    id: 1,
    img: "/images/kazhuga_logo.jpg",
    linkedin: "https://www.linkedin.com/company/kazhuga/",
    role: "Full Stack Developer Intern",
    company: "Kazhuga",
    date: "Sept 2025 - Nov 2025",
    desc: [
      "Architected a full-stack React-based buyer-seller platform with 3 dynamic dashboards, processing 50+ monthly registrations and 100+ admin approvals via custom-built REST APIs.",
      "Engineered a real-time notification system and a requirements-tracking layout for 20+ buyer inputs, achieving 100% Figma design fidelity to enhance user experience and clarity.",
      "Implemented functional admin dashboard tabs and approval workflows for 50+ users, removing persistent notification banners with a refresh-persistent hide feature.",
    ],
    skills: [
      "ReactJS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "REST APIs",
      "JavaScript",
      "TypeScript",
      "Real-time Notifications",
      "Admin Dashboard",
      "Figma",
    ],
    location: "Remote",
  },
];
export const education = [
  {
    id: 0,
    img:"https://ik.imagekit.io/shakti13priya/btech.jpg?updatedAt=1752230015829",
    school: "Indian Institute of Information Technology Ranchi",
    date: "Nov 2022 - May 2026",
    grade: "7.8 CGPA | (Highest: 9.5) ",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Indian Institute of Information Technology Ranchi.  I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. During my college journey I have solved over 600+ problems solved on coding platforms and my Top 10% ranking on LeetCode. I advanced to the penultimate round of Google Girl Hackathon 2k25 and was honored by the title of Miss IIIT at my college fest - Ephemere 2022 which reflects my leadership and people skills. ",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://ik.imagekit.io/shakti13priya/12th.jpg?updatedAt=1752230015838",
    school: "Greendland Public School",
    date: "Apr 2019 - Apr 2021",
    grade: "88.6%",
    desc: "I completed my class 12 high school education at Greendland Public School, Ranchi, where I studied Computer Science, among with other subjects.",
    degree: "CBSE(XII), with Computer Science",
  },
  {
    id: 2,
    img:"https://ik.imagekit.io/shakti13priya/10th.gif?updatedAt=1752230015793",
    school: "Bridgeford School, Ranchi",
    date: "Apr 2018 - Apr 2019",
    grade: "97.8%",
    desc: "I completed my class 10 education at Bridgeford School, Ranchi, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 12,
    title: "Pixxel",
    date: "Aug 2025 - Sept 2025",
    description: "Pixxel is an AI-powered image editing platform with real-time transformations, secure Clerk authentication, optimized performance via ImageKit, and exclusive Pro features - advanced AI tools.",
      image:
      "https://ik.imagekit.io/shakti13priya/Screenshot%202025-09-09%20192859.png?updatedAt=1757426377646",
    tags: [
      "Next JS 15",
      "React Js",
      "Tailwind CSS",
      "Shadcn UI",
      " ",
      "MongoDB",
      "Google Gemini API",
      "ImageKit API"
    ],
    category: "fullstack",
    github: "https://github.com/shaktipriya13/Pixxel",
    webapp: "https://pixxel-two.vercel.app/",
  },
  {
    id: 12,
    title: "WriteFlow",
    date: "Jun 2025 - July 2025",
    description:
      "WriteFlow is an AI-powered full-stack blogging platform that allows users to generate, manage, and publish blog content with ease. Built using the MERN stack, it integrates Google Gemini for content generation and ImageKit for optimized image handling. Includes a secure admin dashboard for blog and comment moderation.",
    image:
      "https://ik.imagekit.io/shakti13priya/blog.png?updatedAt=1752230632957",
    tags: [
      "React Js",
      "Tailwind CSS",
      "Node Js",
      "Express Js",
      "MongoDB",
      "Google Gemini API",
      "ImageKit API"
    ],
    category: "fullstack",
    github: "https://github.com/shaktipriya13/WriteFlow-MERN-BlogApp",
    webapp: "https://write-flow-git-main-priyashakti68-gmailcoms-projects.vercel.app/",
  },
  {
    id: 10,
    title: "PingDrop",
    date: "Jun 2025",
    description:
      "PingDrop is a real-time chat application built using the MERN stack and Socket.io. It allows users to chat instantly with online status updates. The frontend is built with React, Redux Toolkit, and Tailwind CSS, offering a responsive and interactive UI. Cloudinary is used for image uploads, and JWT-based authentication ensures secure user sessions. \nThe backend is developed using Express.js and Mongoose, connected to MongoDB Atlas, and deployed on Render for scalability and performance.",
    image:
        "https://ik.imagekit.io/shakti13priya/chatapp.png?updatedAt=1752230632711",
    tags: [
      "MERN",
      "Socket.io",
      "Cloudinary",
      "JWT",
      "Tailwind CSS",
      "Redux Toolkit",
      "MongoDB Atlas",
      "Render",
      "Express.js",
      "Mongoose",
    ],
    category: "fullstack",
    github: "https://github.com/shaktipriya13/PingDrop", // Replace with actual repo link
    webapp: "https://pingdrop.onrender.com/login/", // Replace with actual live app link if hosted
  },

  // {
  //   id: 11,
  //   title: "Timora",
  //   date: "May 2025",
  //   description:
  //     "Timora is a full-stack e-commerce platform focused on selling premium watches. It allows users to browse products, manage their cart, and make secure payments. The application features a robust RESTful API built with Express.js and Node.js, incorporating secure authentication via JWT, password hashing with bcrypt, and role-based access control. Razorpay is integrated for smooth and secure payment processing. The entire platform is deployed on Render, backed by MongoDB Atlas for reliable data storage and scalability.",
  //   image:
  //       "https://ik.imagekit.io/shakti13priya/ecome.png?updatedAt=1752230633180",
  //   tags: [
  //     "MERN",
  //     "Razorpay",
  //     "JWT",
  //     "Bcrypt",
  //     "MongoDB Atlas",
  //     "Render",
  //     "Express.js",
  //     "Node.js",
  //     "React.js",
  //     "E-commerce",
  //   ],
  //   category: "fullstack",
  //   github: "https://github.com/shaktipriya13/Timora--Ecommerce-website", // Replace with actual repo link
  //   webapp: "https://timora-shaktipriya.onrender.com/", // Replace with actual deployed app link
  // },

  {
    id: 12,
    title: "Music App NextJS",
    date: "April 2025",
    description:
      "Music App NextJS is a fully responsive website designed for a music academy to showcase and enroll students in various music courses. Built using Next.js, TypeScript, Tailwind CSS, and Acertainity UI, it offers an engaging UI with interactive components and smooth transitions. The platform uses Framer Motion for animations and integrates Acertainity UI components.",
    image:
        "https://ik.imagekit.io/shakti13priya/music.png?updatedAt=1752230636865",
    tags: [
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "Framer Motion",
      "Acertainity UI",
      "ESLint",
      "PostCSS",
      "Responsive Design",
      "Modular Components"
    ],
    category: "frontend",
    github: "https://github.com/shaktipriya13",
    webapp: "https://music-courses-selling-website-l6f6.vercel.app/",
  },

  {
    id: 14,
    title: "TubNest Backend API",
    date: "May 2025",
    description:
      "TubNest is the backend of a video-sharing platform, built using Node.js, Express.js, and MongoDB. The project implements complete RESTful APIs for user authentication, video upload, comment management, and like/dislike functionality. It uses JWT for secure authentication, Multer for video uploads, and Cloudinary for media storage. The backend is modular, scalable, and follows best practices with proper error handling, validation (using express-validator), and secure middleware. Deployed on Render and tested with Postman, the API enables robust interaction between frontend and database.",
    image:
    "https://ik.imagekit.io/shakti13priya/Screenshot%202025-07-11%20174523.png?updatedAt=1752236190594",
    tags: [
      "Node.js",
      "Express.js",
      "MongoDB",
      "JWT Authentication",
      "REST API",
      "Cloudinary",
      "Multer",
      "Postman",
      "Render Deployment",
      "Secure Middleware"
    ],
    category: "backend",
    github: "https://github.com/shaktipriya13/TubeNest-A-Video-Streaming-Social-Platform-Backend", // Replace if your repo URL is different
    webapp:
    "https://raw.githubusercontent.com/shaktipriya13/TubeNest-A-Video-Streaming-Social-Platform-Backend/main/docs/TubeNest-Backend-API-Collection.json",  
  },
  {
    "id": "88",
    "title": "Chapter Performance API",
    "date": "June 2025",
    "desc": "A RESTful API for managing chapters in a performance dashboard with filtering, pagination, caching using Redis, secure uploads, and rate-limiting. Deployed on Render and AWS EC2 with GitHub Actions CI/CD.",
    "image": "https://ik.imagekit.io/shakti13priya/chapter.png?updatedAt=1752230632037",
    "tags": [
      "Node.js",
      "Express",
      "MongoDB",
      "Redis",
      "Multer",
      "JWT",
      "CI/CD",
      "Render",
      "AWS EC2"
    ],
    "category": "backend",
    "github": "https://github.com/shaktipriya13/Chapter-Performance-API",
    "webapp": "https://www.postman.com/shakti-priya/mathongo-api/collection/ffg7utw/mathongo-chapter-performance-dashboard-api?action=share&creator=37155607"
  },


  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },

  // {
  //   id: 5,
  //   title: "Currency Converter App",
  //   date: "April 2025",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  {
    id: 16,
    title: "Currency Converter",
    date: "April 2025",
    description:
      "A clean and responsive React app that converts currency values in real time using a public exchange rate API. It demonstrates the use of custom React hooks, reusable components, and API integration. Built with performance and simplicity in mind.",
    image:
        "https://ik.imagekit.io/shakti13priya/curr.png?updatedAt=1752234794155",
    tags: ["React Js", "Custom Hooks", "API", "Netlify"],
    category: "frontend",
    github: "https://github.com/shaktipriya13/currencyConvertor",
    webapp: "https://currency-convertor-shaktip.netlify.app/",
  },

  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
  {
    "id": 7,
    "title": "React Password Generator",
    "date": "Feb 2025",
    "description": "An interactive and user-friendly password generator built with React and styled using Tailwind CSS. It allows users to generate secure passwords with custom length, numbers, and special characters. Includes clipboard copy support and real-time password generation using React Hooks.",
    "image": 
      "https://ik.imagekit.io/shakti13priya/pswd.png?updatedAt=1752234793821",
    "tags": ["React Js", "Hooks", "Tailwind CSS", "Clipboard API"],
    "category": "frontend",
    "github": "https://github.com/shaktipriya13/Password-Generator",
    "webapp": "https://password-generator-shaktip.netlify.app/"
  },
  {
    "id": 7,
    "title": "Travelia - Landing Page",
    "date": "Jul 2025",
    "description": "Travelia is a fully responsive travel-themed landing page built with HTML, CSS, and JavaScript. Designed with a mobile-first approach, it offers an engaging, clean UI and intuitive navigation. Ideal for travel agencies or developers learning responsive web design.",
    "image": 
    "https://ik.imagekit.io/shakti13priya/tourist.png?updatedAt=1752235199019",
    "tags": ["HTML", "CSS", "JavaScript", "Responsive Design"],
    "category": "frontend",
    "github": "https://github.com/your-username/travelia",
    "webapp": "https://travelia-tours-shaktip.netlify.app/"
  }


];

